import { render, staticRenderFns } from "./ViewEditPerson.vue?vue&type=template&id=f9f763c6&scoped=true&"
import script from "./ViewEditPerson.vue?vue&type=script&lang=js&"
export * from "./ViewEditPerson.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditPerson.vue?vue&type=style&index=0&id=f9f763c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f763c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VProgressCircular,VRow,VSelect,VTextField})
